/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/no-cycle
import reportingApi from '../api/reportingApi';
// eslint-disable-next-line import/no-cycle
import storageApi from '@/modules/storage/api/storageApi';
import * as rootTypes from '@/store/types';
import * as types from './types';

const actions = {
  [types.FETCH_PUBLISHER_IDS_WITH_STATS]: (context, payload) => reportingApi
    .getPublisherIdsWithStats(payload)
    .then((publisherIds) => publisherIds)
    .catch((error) => error),
  [types.FETCH_CAMPAIGN_PUBLISHER_STATS]: (context, payload) => reportingApi
    .getPublisherStats(payload)
    .then((publisherStats) => publisherStats)
    .catch((error) => error),
  [types.FETCH_DAILY_STATS]: (context, payload) => reportingApi
    .getDailyStats(payload)
    .then((dailyStats) => dailyStats)
    .catch((error) => error),
  [types.FETCH_CAMPAIGN_CONTENT_DAILY_STATS]: (context, payload) => reportingApi
    .getContentDailyStats(payload)
    .then((publisherDailyStats) => publisherDailyStats)
    .catch((error) => error),
  [types.FETCH_GEO_LOCATION_IDS_WITH_STATS]: (context, payload) => reportingApi
    .getGeoLocationIdsWithStats(payload)
    .then((publisherIds) => publisherIds)
    .catch((error) => error),
  [types.FETCH_GEO_STATS]: (context, payload) => reportingApi
    .getGeoStats(payload)
    .then((publisherIds) => publisherIds)
    .catch((error) => error),
  [types.DOWNLOAD_CONTENT_REPORT_CSV]: (context, payload) => reportingApi
    .downloadContentReportCSV(payload)
    .then((csvContent) => csvContent)
    .catch((error) => error),
  [types.DOWNLOAD_GEO_REPORT_CSV]: (context, payload) => reportingApi
    .downloadGeoReportCSV(payload)
    .then((csvContent) => csvContent)
    .catch((error) => error),
  [types.FETCH_OVERALL_CREATIVE_CAMPAIGN_STATS]: (context, payload) => reportingApi
    .getOverallCreativeCampaignStats(payload)
    .then((stats) => stats)
    .catch((error) => error),
  [types.FETCH_REPORT_STATEMENTS_FOR_TYPE]: (context, payload) => {
    if (context.state.reportingStatements.hasOwnProperty([payload])) return context.state.reportingStatements[payload];
    return reportingApi.getReportStatementsForType({
      campaignId: context.rootState.campaigns.campaign.id,
      type: payload,
    })
      .then((response) => {
        context.commit(types.SET_REPORT_STATEMENTS_FOR_TYPE, {
          type: payload,
          statements: response || [],
        });
        return response || [];
      })
      .catch((error) => {
        throw error;
      });
  },
  [types.UPDATE_REPORT_STATEMENTS_FOR_TYPE]: (context, payload) => reportingApi.putReportStatementsForType({
    campaignId: context.rootState.campaigns.campaign.id,
    body: {
      reportType: payload.type,
      enabledConfigurationIds: payload.enabledIds,
      replacements: payload.hasOwnProperty('replacements') && Object.keys(payload.replacements).length ? payload.replacements : new Map(),
    },
  })
    .then(() => {
      context.commit(types.SET_REPORT_STATEMENTS_FOR_TYPE, {
        type: payload.type,
        statements: payload.fullStatementsList,
      });
    })
    .catch((error) => {
      throw error;
    }),
  [types.FETCH_CAMPAIGN_REPORT_CONFIGURATION]: (context) => reportingApi.getCampaignReportConfiguration({
    campaignId: context.rootState.campaigns.campaign.id,
  })
    .then((response) => {
      context.commit(types.SET_CAMPAIGN_REPORT_CONFIGURATION, response);
      return response;
    })
    .catch((error) => {
      throw error;
    }),
  [types.SHOULD_SUPPRESS_GEO_TAB]: async (context, payload) => {
    for (const id of payload.campaignIds) {
      const response = await reportingApi.getCampaignReportConfiguration({ campaignId: id });
      if (response.properties?.suppressGeoTab === 'true') {
        return true;
      }
    }
    return false;
  },
  [types.UPDATE_CAMPAIGN_REPORT_CONFIGURATION]: (context, payload) => reportingApi.patchCampaignReportConfiguration({
    campaignId: context.rootState.campaigns.campaign.id,
    body: payload.body,
  })
    .then((response) => {
      context.commit(types.SET_CAMPAIGN_REPORT_CONFIGURATION, response);
    })
    .catch((error) => {
      context.commit(
        rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'Update was unsuccessful',
          type: 'danger',
        }, { root: true },
      );
      throw error;
    }),
  [types.PUBLISH_CAMPAIGN_REPORT_STATEMENTS]: (context) => reportingApi.publishCampaignReportStatements({
    campaignId: context.rootState.campaigns.campaign.id,
  })
    .then(() => {
      context.commit(types.PUBLISH_CAMPAIGN_REPORT_STATEMENTS, true);
      context.commit(
        rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'End of Campaign Highlights have been published and shared',
          type: 'info',
        }, { root: true },
      );
    })
    .catch((error) => {
      context.commit(
        rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'OOPS, SOMETHING WENT WRONG!',
          type: 'danger',
        }, { root: true },
      );
      throw error;
    }),
  [types.UPDATE_SUMMARY_ENABLED_STATEMENTS]: (context, payload) => reportingApi.patchSummaryEnabledStatements({
    campaignId: context.rootState.campaigns.campaign.id,
    body: {
      enabledSummaryConfigurationIds: payload,
    },
  })
    .then(() => {
      context.commit(types.UPDATE_SUMMARY_ENABLED_STATEMENTS, payload);
    })
    .catch((error) => {
      context.commit(
        rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'OOPS, SOMETHING WENT WRONG!',
          type: 'danger',
        }, { root: true },
      );
      throw error;
    }),
  [types.UPLOAD_CAMPAIGN_SCREENSHOT]: async (context, formData) => {
    const response = await storageApi.uploadFile(context.rootState.campaigns.campaign.id, {
      bucket: 'SCREENSHOT',
      formData,
    });
    const { name } = response;
    context.commit(types.ADD_CAMPAIGN_SCREENSHOTS_NAME, name);
    return name;
  },
  [types.FETCH_CAMPAIGN_SCREENSHOT_NAMES]: (context) => storageApi.getFileNames(context.rootState.campaigns.campaign.id, {
    bucket: 'SCREENSHOT',
  })
    .then((response) => {
      const fileNames = response?.files?.map((file) => file.name);
      context.commit(types.SET_CAMPAIGN_SCREENSHOTS_NAMES, fileNames);
      return fileNames;
    })
    .catch(() => {
      context.commit(types.SET_CAMPAIGN_SCREENSHOTS_NAMES, []);
      return [];
    }),
  [types.FETCH_CAMPAIGN_SCREENSHOT_IMAGE]: (context, fileName) => storageApi.getFile(context.rootState.campaigns.campaign.id, {
    bucket: 'SCREENSHOT',
    fileName,
  }).then((response) => response.content)
    .catch(() => []),
  [types.DOWNLOAD_SCREENSHOTS_ARCHIVE]: (context) => storageApi.downloadAnArchive(context.rootState.campaigns.campaign.id, {
    bucket: 'SCREENSHOT',
  })
    .then((response) => response)
    .catch((error) => error),
  [types.DELETE_CAMPAIGN_SCREENSHOT]: (context, fileName) => storageApi.deleteFile(context.rootState.campaigns.campaign.id, {
    bucket: 'SCREENSHOT',
    fileName,
  })
    .then((response) => {
      context.commit(types.REMOVE_CAMPAIGN_SCREENSHOTS_NAME, fileName);
      return response;
    })
    .catch((error) => error),
};

export default actions;
